import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from "react";
import { AboutModal } from "./AboutModal";

interface AboutDialog {
  open: () => void;
}

const AboutContext = createContext<AboutDialog | null>(null);

/**
 * The About dialog for the signed-in shell, opened with useAboutDialog(). Like Send feedback, it lives here,
 * not in the sidebar, so it survives the mobile drawer closing (the drawer unmounts its content).
 */
export function AboutProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  const value = useMemo(() => ({ open }), [open]);
  return (
    <AboutContext.Provider value={value}>
      {children}
      {isOpen && <AboutModal onClose={() => setOpen(false)} />}
    </AboutContext.Provider>
  );
}

const NONE: AboutDialog = { open: () => {} };

/** Open the About dialog. */
export function useAboutDialog(): AboutDialog {
  return useContext(AboutContext) ?? NONE;
}
